"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsonpathPlus = require("jsonpath-plus");
var getValueFromJson = function getValueFromJson(jsonObj, jsonPath) {
  if (jsonPath === 'undefined' || !jsonPath) {
    return "";
  } else {
    return (0, _jsonpathPlus.JSONPath)({
      path: jsonPath,
      json: jsonObj
    });
  }
};
var _default = getValueFromJson;
exports.default = _default;